// extracted by mini-css-extract-plugin
module.exports = {"lineLength":"styles__lineLength___1p9s2","details":"styles__details___2yWkX"};